import { env } from "@/utils/configs/env";
import { FieldProperties, TableSpec } from "alurkerja-ui";

type IColumn = {
  key: string;
  label: string;
  type?: 'text' | 'date';
};

export const useCustomSpec = (
  path: string,
  { columns, title }: { columns: IColumn[]; title?: string }
): TableSpec => {
  const makeField = (columns: IColumn[]): { [x: string]: FieldProperties } => {
    const fields: { [x: string]: FieldProperties } = {};

    columns.forEach(({ key, label }, index) => {
      fields[key] = {
        name: key,
        label: label,
        required: true,
        searchable: true,
        filterable: true,
        sortable: true,
        type: "text",
        form_field_type: "INPUT_TEXT",
        primary: false,
        is_hidden_in_create: false,
        is_hidden_in_edit: false,
        is_hidden_in_list: false,
        is_hidden_in_detail: false,
        rules: [],
        format: "",
        prefix: "",
        suffix: "",
        list_order: index + 1,
        create_order: 1,
        edit_order: 1,
      };
    });

    return fields;
  };

  return {
    show_as_menu: true,
    name: "useSpec",
    is_bpmn: false,
    is_usertask: false,
    can_bulk: false,
    can_create: true,
    can_delete: true,
    can_edit: true,
    can_detail: true,
    label: title ?? "",
    base_url: env.apiBaseUrl,
    path: path,
    description: "Field Dari ",
    header_action: [
      {
        label: "Tambah",
        action_label: "Tambah",
        method: "post",
        form_type: "modal",
        path: "/api/crud/project",
        icon: "plus",
        type: "primary",
      },
    ],
    field_action: [],
    languages: {
      pagination_info: "Memunculkan data dari {page} sampai {limit} total {total}",
      empty_data: "Tidak ada data yang ditampilkan",
      filter_title: "Filter",
      filter_submit: "Filter",
      filter_reset: "Clear Filter",
      filter_cancel: "Kembali",
    },
    fields: makeField(columns),
  };
};
